<template>
  <app-layout>
    <template #header>
      <AppHead title="Order History"/>
      <h3 class="title mb-2">
        Order History <span v-if="tu != null">for User {{ tu.first_name }} {{ tu.last_name }}</span>
        <span v-else-if="location != null">for Location {{ location.company_name }}</span>
      </h3>
    </template>

    <div class="tab-content mt-4">
      <ul class="nav nav-tabs nav-justified">
        <li class="nav-item">
          <a class="nav-link active" href="#wholesale-orders-tab" data-toggle="tab" role="tab">Wholesale Orders</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tu-orders-tab" data-toggle="tab" role="tab">Customer Orders</a>
        </li>
      </ul>

      <card class="tab-pane show active border-top-0 fade" id="wholesale-orders-tab" role="tabpanel">
        <OrdersDatatable :orders="wholesaleOrders"></OrdersDatatable>
      </card>
      
      <card class="tab-pane border-top-0 fade" id="tu-orders-tab" role="tabpanel">
        <div class="row mb-4">
          <div class="col-lg-5">
            <Multiselect
              v-model="location_id"
              :options="locations"
              :searchable="true"
              placeholder="Location"
              id="location_select"
              class="mb-2 mb-lg-0"
              @change="selectLocation"
              @clear="clearLocation"
            />
          </div>

          <div class="col-lg-5">
            <Multiselect
              v-model="user_id"
              :options="users"
              :searchable="true"
              placeholder="User"
              id="user_select"
              class="mb-2 mb-lg-0"
              @change="selectUser"
              @clear="clearUser"
            />
          </div>

          <div class="col-lg-2 mt-2 mt-lg-0">
            <jet-button class="w-100" icon="fas fa-user" :goesTo="route('shop.create')">Create User</jet-button>
          </div>
        </div>

        <OrdersDatatable :orders="orders"></OrdersDatatable>
      </card>
      
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'
import Multiselect from '@vueform/multiselect'
import OrdersDatatable from "@/Components/Dashboard/OrdersDatatable";

export default {
  components: {
    OrdersDatatable,
    AppLayout,
    FlashMessages,
    Icon,
    Multiselect
  },
  props: {
    user: Object,
    orders: Array,
    wholesaleOrders: Array,
    total_orders: Number,
    locations: Array,
    location: Object,
    users: Array,
    tu: Object
  },
  data() {
    return {
      location_id: this.location ? this.location.id : null,
      user_id: this.tu ? this.tu.id : null,
    }
  },
  methods: {
    selectLocation(id) {
      if (id) {
        this.$inertia.visit(this.route('dashboard.location', id));
      }
    },
    clearLocation() {
      this.$inertia.visit(this.route('dashboard.reset'));
    },
    selectUser(id) {
      if (id) {
        axios.get(route('dashboard.user', id)).then(() => {
          this.$inertia.visit(this.route('mtd.orders.list'));
        });
      }
    },
    clearUser() {
      axios.get(route('dashboard.resetuser')).then(() => {
        this.$inertia.visit(this.route('mtd.orders.list'));
      });
    },
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
